/* eslint-disable max-classes-per-file */

/**
 * Class which describes the message.
 * @abstract
 */
export class Message {
  static get defaultParams() {
    return {
      /**
       * The title of the message.
       * Can be used as a list title or some kind of notification.
       */
      title: '',

      /**
       * Type of message. For example: `sent` or `received`.
       */
      type: null,

      /**
       * The content that contains the message.
       * Can be either a string or an object or an array.
       */
      content: null,

      /**
       * Flag is intended for user feedback.
       * If `true`, the corresponding component will be displayed.
       */
      hasFeedback: false,

      /**
       * Contains the original message object from the backend.
       * Designed to not produce unnecessary properties on a standard message object.
       */
      original: {},

      /**
       *Property to which you can use for attach some elements.
       */
      attachments: []
    };
  }

  constructor(params = Message.defaultParams) {
    const { title, type, content, hasFeedback, original, attachments } = {
      ...Message.defaultParams,
      ...params
    };

    this.title = title;
    this.type = type;
    this.content = content;
    this.original = original;
    this.hasFeedback = hasFeedback;
    this.attachments = attachments;
  }

  attach(attachment) {
    this.attachments.push(attachment);
    return this;
  }
}

export class HTMLMessage extends Message {}
export class HTMLMessageWithScroll extends Message {}
export class TextMessage extends Message {}
export class TextMessageWithTranslation extends Message {}
export class InfoMessage extends Message {}
export class TreeMessage extends Message {}
export class RelatedQuestionsButton extends Message {}
export class QuestionsMessage extends Message {}
export class QuestionsMessageProjects extends Message {}
export class EscalationMessages extends Message {}
export class LikeMessage extends Message {}
export class DislikeMessage extends Message {}
export class CarouselMessage extends Message {}
export class JsonSelectMessage extends Message {}
